<template lang="pug">
figure.wagtail-enlarge-image
  div(:class="isEnlarging ? 'wagtail-enlarge-image__img-container wagtail-enlarge-image__img-container--enlarging' : 'wagtail-enlarge-image__img-container'")
    img(:src="$getImgUrl.origin(value.image.download_path)" :alt="value.description").wagtail-enlarge-image__img
    a(@click="isEnlarging=false" :class="isEnlarging ? 'close-icon close-icon--visible' : 'close-icon'")
      IconBase
        IconClose
    a(@click.prevent="isEnlarging=true" :class="!isEnlarging ? 'scale-icon scale-icon--visible' : 'scale-icon'")
      IconBase
        IconScale
  figcaption.wagtail-enlarge-image__description {{ value.description }}
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isEnlarging: false
    }
  }
}
</script>

<style lang="scss" scoped>
.wagtail-enlarge-image {
  width: 100%;
  position: relative;

  &__img-container {
    width: 100%;
    margin-bottom: 20px;
    transition: 0.3s;
    position: relative;
    z-index: 222;
  }

  &__img-container--enlarging {
    transform: scale(1.5);

    @media (max-width: 1569px) {
      transform: scale(1.3);
    }

    @media (max-width: 1439px) {
      transform: scale(1.4);
    }

    @media (max-width: 1279px) {
      transform: scale(1);
    }
  }

  &__img {
    width: 100%;
  }

  &__description {
    color: $gray;
    font-size: 16px;
  }
}

.close-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  opacity: 0;
  transition: 0.3s;
}

.scale-icon {
  position: absolute;
  bottom: 20px;
  right: 20px;
  opacity: 0;
  transition: 0.3s;
}

.scale-icon--visible,
.close-icon--visible {
  cursor: pointer;
  opacity: 1;
}

@media (max-width: 1279px) {

  .scale-icon,
  .scale-icon--visible,
  .close-icon,
  .close-icon--visible {
    display: none;
  }
}
</style>